export default {
  GET_FEEDS_REQUEST: 'GET_FEEDS_REQUEST',
  GET_FEEDS_SUCCESS: 'GET_FEEDS_SUCCESS',
  GET_FEEDS_FAILURE: 'GET_FEEDS_FAILURE',
};
